<template>
  <div class="global-content has-tab">
    <router-view v-slot="{ Component }" v-if="userStore.routerAlive">
      <keep-alive :include="keepAliveList">
        <component :is="Component" />
      </keep-alive>
    </router-view>
  </div>
</template>

<script>
export default {
  name: "GlobalContent"
}
</script>
<script setup>
import {computed} from "vue";
import {useUserStore} from "@/store/module/user";

const userStore = useUserStore()
const keepAliveList = computed(() =>
    userStore.keepAliveList.map((item) => item.name)
);
</script>

<style scoped>
.global-content {
  height:100%;
  overflow: auto;
}

.global-content.has-tab {
  height:calc(100% - 44px);
  //height:100%;
  overflow: auto;
}

.global-content::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.global-content::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #e2e2e2;
}
</style>
